import { IconButton } from "@mui/material";
import styled from "styled-components";
import {
    ContentWrapper as FormContentWrapper,
    ErrorMessage as FormErrorMessage,
    FormRow,
    FormTitle,
    FormWrapper,
    Input,
    InputWrapper,
    Label,
} from "../../../../../shared/components/FormType/Styled";
import { color } from "../../../../../shared/styles";
import {
    AddButtonText as ContactAddButtonText,
    StyledAddButton as ContactAddButton,
} from "../ContactList/Styled";

export const AddressSection = styled(FormContentWrapper).attrs({
    as: "section",
})`
    justify-content: flex-start;
    overflow: visible;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const Heading = styled(FormTitle)`
    flex: 1;
    text-align: left;
`;

export const Counter = styled.span`
    padding-right: 4px;
    color: ${color.emphasis.NEUTRAL_N70};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
`;

export const AddressList = styled(FormWrapper)`
    height: auto;
    gap: 16px;
`;

export const AddressGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${color.emphasis.NEUTRAL_N10};

    &:last-child {
        padding-bottom: 0;
        border-bottom: 0;
    }
`;

export const DefaultRow = styled.div`
    display: flex;
    align-items: center;
    margin-left: 168px;

    @media (max-width: 768px) {
        margin-left: 0;
    }
`;

export const DefaultControl = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    cursor: pointer;

    input {
        width: 16px;
        height: 16px;
        margin: 0;
        accent-color: ${color.primary.BLUE_B100};
    }
`;

export const DefaultBadge = styled.span`
    padding: 2px 8px;
    border: 1px solid ${color.primary.BLUE_B100};
    border-radius: 4px;
    color: ${color.primary.BLUE_B100};
    font-size: 16px;
    line-height: 22px;
`;

export const FieldRow = styled(FormRow)`
    position: relative;
`;

export const FieldLabel = styled(Label)`
    flex: 0 0 160px;
`;

export const FieldInputWrapper = styled(InputWrapper)`
    position: relative;
`;

export const LabelInput = styled(Input)<{ $invalid?: boolean }>`
    border-color: ${(props) =>
        props.$invalid ? color.status.FAIL : color.emphasis.NEUTRAL_N70};
`;

export const AddressInput = styled(Input)<{ $invalid?: boolean }>`
    border-color: ${(props) =>
        props.$invalid ? color.status.FAIL : color.emphasis.NEUTRAL_N70};
`;

export const ErrorText = styled(FormErrorMessage)`
    margin-top: 6px;
`;

export const ActionSlot = styled.div`
    display: flex;
    flex: 0 0 48px;
    height: 36px;
    margin-left: 8px;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        flex-basis: 40px;
        margin-left: 4px;
    }
`;

export const DeleteButton = styled(IconButton)`
    && {
        width: 36px;
        height: 36px;
        padding: 8px;
        border: 0;
        border-radius: 5px;
        background: transparent;
        color: ${color.emphasis.NEUTRAL_N70};
        transition: background-color 140ms ease, color 140ms ease,
            transform 80ms ease;

        & .MuiSvgIcon-root {
            width: 20px;
            height: 20px;
        }

        &:hover {
            background: ${color.status.DANGER_LIGHT};
            color: ${color.status.FAIL};
        }

        &:focus-visible {
            outline: 2px solid ${color.primary.BLUE_B100};
            outline-offset: 2px;
        }

        &:active {
            transform: translateY(1px);
        }
    }
`;

export const EmptyState = styled.div`
    margin-top: 16px;
    margin-left: 168px;
    color: ${color.emphasis.NEUTRAL_N70};
    font-size: 14px;
    line-height: 22px;
`;

export const AddButton = styled(ContactAddButton)`
    width: fit-content;

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    &:hover:disabled {
        text-decoration: none;
    }
`;

export const AddButtonText = styled(ContactAddButtonText)``;
